import { Autocomplete, Box, Button, TextField} from "@mui/material";
import { getConversationClients } from "api/services/communication";

import DialogWrapper from "components/DialogWrapper";
import Loader from "components/Loader";
import { useState } from "react";
import { useQuery} from "react-query";
import { DialogProps, ResType } from "types";
import { getCountryCode } from "validations/phoneNumbr";

interface Props extends DialogProps {
    onClientSelect: (client: { id: string; displayName: string; mobileNumber: string }) => void;

}

function AddClientPopUp(props: Props) {
    const { open, setOpen } = props;
    const [clientError, setClientError] = useState(false);
   
    const [selectedClient, setSelectedClient] = useState({
        id: "",
        displayName: "",
        mobileNumber: "",
        countryCode:"",
      });


console.log(selectedClient,'slected')
    const { data: clients, isLoading: clientsLoading }: ResType = useQuery(["whatsapp-conversation"], getConversationClients, {
        enabled: open,
    });
console.log(clients,'clientsss')

   
const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!selectedClient.id) {
      setClientError(true);
      return;
    }
    props.onClientSelect(selectedClient);
  };

    const handleCancel = () => {
        setSelectedClient({
            id: "",
            displayName: "",
            mobileNumber: "",
            countryCode:""
        })
        setOpen(false);
    };

   

    if (clientsLoading) return <Loader />;

    return (
        <DialogWrapper
            title="Select client you wanted to message"
            open={open}
            setOpen={setOpen}
        >
            {clientsLoading ? <Loader /> : 
            <form onSubmit={handleSubmit}>
                <Box mt={3} display="flex" flexDirection="column">
                    <Box>
                        <Autocomplete
                        options={clients?.data || []}
                        getOptionLabel={(option) => option.displayName || ''}
                        style={{
                            width: "100%",
                            fontSize: "10px",
                            padding: "0px 0px",
                            marginBottom:20
                        }}
                        value={selectedClient}
                        onChange={(e, newValue) => {
                            if (newValue) {
                                console.log(newValue,'newvalue')
                              setSelectedClient({
                                id: newValue.id,
                                displayName: newValue.displayName,
                                mobileNumber: newValue.mobileNumber, // <- make sure this exists
                                countryCode: newValue.countryCode
                              });
                              setClientError(false);
                            }
                          }} 
                          
                          renderInput={(params) => (
                            <TextField
                            {...params}
                            variant="outlined"
                            size="small"
                            fullWidth
                            required
                            label='Clients'
                            error={clientError}
                            helperText={clientError ? 'Please select a client' : ''} 
                            />
                        )}
                        renderOption={(props, option) => (
                            <li {...props} key={option.id}> 
                                {option.displayName}
                            </li>
                        )}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        />
                    </Box>
                    <Box>
                    <TextField
  label="Mobile Number"
  variant="outlined"
  size="small"
  fullWidth
  value={`${getCountryCode(selectedClient?.countryCode) || 91}${selectedClient?.mobileNumber}`}
  disabled
  style={{ marginBottom: 20 }}
/>


                    </Box>
                    <Box display="flex" justifyContent={"flex-end"}>
                        <Button onClick={handleCancel} style={{ width: "100px", marginRight: "10px" }} color="secondary" variant="outlined" >Cancel</Button>
                        <Button
                            style={{ width: "100px" }}
                            // disabled={isLoading}
                            type="submit"
                            size="large"
                            color="primary"
                            variant="contained"
                        >
                            Chat
                        </Button>
                    </Box>
                </Box>
            </form>}
        </DialogWrapper>
    );
}

export default AddClientPopUp;